import { render, staticRenderFns } from "./priceDialog.vue?vue&type=template&id=2d3b07a5&scoped=true"
import script from "./priceDialog.vue?vue&type=script&lang=js"
export * from "./priceDialog.vue?vue&type=script&lang=js"
import style0 from "./priceDialog.vue?vue&type=style&index=0&id=2d3b07a5&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3b07a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d3b07a5')) {
      api.createRecord('2d3b07a5', component.options)
    } else {
      api.reload('2d3b07a5', component.options)
    }
    module.hot.accept("./priceDialog.vue?vue&type=template&id=2d3b07a5&scoped=true", function () {
      api.rerender('2d3b07a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/specialVehicle/priceDialog.vue"
export default component.exports